/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ListTfxRenderJobsParams,
  SuccessResponseDTOListTfxRenderJobDTO,
  SuccessResponseDTOTfxRenderJobCreatedDTO,
  SuccessResponseDTOTfxRenderJobDTO,
  SuccessResponseDTOTfxUploadUrlDTO,
  SuccessResponseDTOVoid,
  TfxArtifactUploadUrlRequestDTO,
  TfxPromptRefUploadUrlRequestDTO,
  TfxRenderJobCompleteRequestDTO,
  TfxRenderJobCreateRequestDTO,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary The caller's recent render jobs, newest first; optional kind filter.
 */
export const listTfxRenderJobs = (params?: ListTfxRenderJobsParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListTfxRenderJobDTO>({
    url: `/admin/api/tfx/render-jobs`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getListTfxRenderJobsQueryKey = (params?: ListTfxRenderJobsParams) => {
  return [`/admin/api/tfx/render-jobs`, ...(params ? [params] : [])] as const;
};

export const getListTfxRenderJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTfxRenderJobs>>,
  TError = unknown,
>(
  params?: ListTfxRenderJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxRenderJobs>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTfxRenderJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTfxRenderJobs>>> = ({ signal }) =>
    listTfxRenderJobs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTfxRenderJobs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTfxRenderJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTfxRenderJobs>>
>;
export type ListTfxRenderJobsQueryError = unknown;

export function useListTfxRenderJobs<
  TData = Awaited<ReturnType<typeof listTfxRenderJobs>>,
  TError = unknown,
>(
  params: undefined | ListTfxRenderJobsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxRenderJobs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTfxRenderJobs>>,
          TError,
          Awaited<ReturnType<typeof listTfxRenderJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTfxRenderJobs<
  TData = Awaited<ReturnType<typeof listTfxRenderJobs>>,
  TError = unknown,
>(
  params?: ListTfxRenderJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxRenderJobs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTfxRenderJobs>>,
          TError,
          Awaited<ReturnType<typeof listTfxRenderJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTfxRenderJobs<
  TData = Awaited<ReturnType<typeof listTfxRenderJobs>>,
  TError = unknown,
>(
  params?: ListTfxRenderJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxRenderJobs>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary The caller's recent render jobs, newest first; optional kind filter.
 */

export function useListTfxRenderJobs<
  TData = Awaited<ReturnType<typeof listTfxRenderJobs>>,
  TError = unknown,
>(
  params?: ListTfxRenderJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxRenderJobs>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListTfxRenderJobsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Queue a render job (SPEC = compile first, PACKAGE = render as-is).
 */
export const createTfxRenderJob = (
  tfxRenderJobCreateRequestDTO: TfxRenderJobCreateRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOTfxRenderJobCreatedDTO>({
    url: `/admin/api/tfx/render-jobs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tfxRenderJobCreateRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getCreateTfxRenderJobMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTfxRenderJob>>,
    TError,
    { data: TfxRenderJobCreateRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTfxRenderJob>>,
  TError,
  { data: TfxRenderJobCreateRequestDTO },
  TContext
> => {
  const mutationKey = ['createTfxRenderJob'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTfxRenderJob>>,
    { data: TfxRenderJobCreateRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createTfxRenderJob(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTfxRenderJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTfxRenderJob>>
>;
export type CreateTfxRenderJobMutationBody = TfxRenderJobCreateRequestDTO;
export type CreateTfxRenderJobMutationError = unknown;

/**
 * @summary Queue a render job (SPEC = compile first, PACKAGE = render as-is).
 */
export const useCreateTfxRenderJob = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTfxRenderJob>>,
      TError,
      { data: TfxRenderJobCreateRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTfxRenderJob>>,
  TError,
  { data: TfxRenderJobCreateRequestDTO },
  TContext
> => {
  const mutationOptions = getCreateTfxRenderJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Worker: presigned PUT for one artifact under render-artifacts/{id}/.
 */
export const createTfxRenderJobArtifactUploadUrl = (
  id: number,
  tfxArtifactUploadUrlRequestDTO: TfxArtifactUploadUrlRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOTfxUploadUrlDTO>({
    url: `/admin/api/tfx/render-jobs/${id}/artifact-upload-url`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tfxArtifactUploadUrlRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getCreateTfxRenderJobArtifactUploadUrlMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTfxRenderJobArtifactUploadUrl>>,
    TError,
    { id: number; data: TfxArtifactUploadUrlRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTfxRenderJobArtifactUploadUrl>>,
  TError,
  { id: number; data: TfxArtifactUploadUrlRequestDTO },
  TContext
> => {
  const mutationKey = ['createTfxRenderJobArtifactUploadUrl'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTfxRenderJobArtifactUploadUrl>>,
    { id: number; data: TfxArtifactUploadUrlRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTfxRenderJobArtifactUploadUrl(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTfxRenderJobArtifactUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTfxRenderJobArtifactUploadUrl>>
>;
export type CreateTfxRenderJobArtifactUploadUrlMutationBody = TfxArtifactUploadUrlRequestDTO;
export type CreateTfxRenderJobArtifactUploadUrlMutationError = unknown;

/**
 * @summary Worker: presigned PUT for one artifact under render-artifacts/{id}/.
 */
export const useCreateTfxRenderJobArtifactUploadUrl = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTfxRenderJobArtifactUploadUrl>>,
      TError,
      { id: number; data: TfxArtifactUploadUrlRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTfxRenderJobArtifactUploadUrl>>,
  TError,
  { id: number; data: TfxArtifactUploadUrlRequestDTO },
  TContext
> => {
  const mutationOptions = getCreateTfxRenderJobArtifactUploadUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Worker: atomically claim the oldest QUEUED job (or reclaim a stale RUNNING one); 204 when there is nothing to claim.
 */
export const claimTfxRenderJob = (signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOTfxRenderJobDTO | void>({
    url: `/admin/api/tfx/render-jobs/claim`,
    method: 'POST',
    ...(signal ? { signal } : {}),
  });
};

export const getClaimTfxRenderJobMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimTfxRenderJob>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof claimTfxRenderJob>>, TError, void, TContext> => {
  const mutationKey = ['claimTfxRenderJob'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimTfxRenderJob>>, void> = () => {
    return claimTfxRenderJob();
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimTfxRenderJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimTfxRenderJob>>
>;

export type ClaimTfxRenderJobMutationError = unknown;

/**
 * @summary Worker: atomically claim the oldest QUEUED job (or reclaim a stale RUNNING one); 204 when there is nothing to claim.
 */
export const useClaimTfxRenderJob = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof claimTfxRenderJob>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof claimTfxRenderJob>>, TError, void, TContext> => {
  const mutationOptions = getClaimTfxRenderJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Worker: report completion, RUNNING to DONE (with artifacts) or FAILED (with error).
 */
export const completeTfxRenderJob = (
  id: number,
  tfxRenderJobCompleteRequestDTO: TfxRenderJobCompleteRequestDTO,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/tfx/render-jobs/${id}/complete`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: tfxRenderJobCompleteRequestDTO,
  });
};

export const getCompleteTfxRenderJobMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeTfxRenderJob>>,
    TError,
    { id: number; data: TfxRenderJobCompleteRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeTfxRenderJob>>,
  TError,
  { id: number; data: TfxRenderJobCompleteRequestDTO },
  TContext
> => {
  const mutationKey = ['completeTfxRenderJob'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeTfxRenderJob>>,
    { id: number; data: TfxRenderJobCompleteRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return completeTfxRenderJob(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteTfxRenderJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeTfxRenderJob>>
>;
export type CompleteTfxRenderJobMutationBody = TfxRenderJobCompleteRequestDTO;
export type CompleteTfxRenderJobMutationError = unknown;

/**
 * @summary Worker: report completion, RUNNING to DONE (with artifacts) or FAILED (with error).
 */
export const useCompleteTfxRenderJob = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeTfxRenderJob>>,
      TError,
      { id: number; data: TfxRenderJobCompleteRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeTfxRenderJob>>,
  TError,
  { id: number; data: TfxRenderJobCompleteRequestDTO },
  TContext
> => {
  const mutationOptions = getCompleteTfxRenderJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Job status incl. artifacts with signed read URLs.
 */
export const getTfxRenderJob = (id: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOTfxRenderJobDTO>({
    url: `/admin/api/tfx/render-jobs/${id}`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetTfxRenderJobQueryKey = (id?: number) => {
  return [`/admin/api/tfx/render-jobs/${id}`] as const;
};

export const getGetTfxRenderJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getTfxRenderJob>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxRenderJob>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTfxRenderJobQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTfxRenderJob>>> = ({ signal }) =>
    getTfxRenderJob(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTfxRenderJob>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTfxRenderJobQueryResult = NonNullable<Awaited<ReturnType<typeof getTfxRenderJob>>>;
export type GetTfxRenderJobQueryError = unknown;

export function useGetTfxRenderJob<
  TData = Awaited<ReturnType<typeof getTfxRenderJob>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxRenderJob>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTfxRenderJob>>,
          TError,
          Awaited<ReturnType<typeof getTfxRenderJob>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTfxRenderJob<
  TData = Awaited<ReturnType<typeof getTfxRenderJob>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxRenderJob>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTfxRenderJob>>,
          TError,
          Awaited<ReturnType<typeof getTfxRenderJob>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTfxRenderJob<
  TData = Awaited<ReturnType<typeof getTfxRenderJob>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxRenderJob>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Job status incl. artifacts with signed read URLs.
 */

export function useGetTfxRenderJob<
  TData = Awaited<ReturnType<typeof getTfxRenderJob>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxRenderJob>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTfxRenderJobQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Presigned PUT for a PROMPT-job reference asset (image/video) under prompt-refs/.
 */
export const createTfxPromptRefUploadUrl = (
  tfxPromptRefUploadUrlRequestDTO: TfxPromptRefUploadUrlRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOTfxUploadUrlDTO>({
    url: `/admin/api/tfx/render-jobs/prompt-ref-upload-url`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tfxPromptRefUploadUrlRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getCreateTfxPromptRefUploadUrlMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTfxPromptRefUploadUrl>>,
    TError,
    { data: TfxPromptRefUploadUrlRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTfxPromptRefUploadUrl>>,
  TError,
  { data: TfxPromptRefUploadUrlRequestDTO },
  TContext
> => {
  const mutationKey = ['createTfxPromptRefUploadUrl'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTfxPromptRefUploadUrl>>,
    { data: TfxPromptRefUploadUrlRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createTfxPromptRefUploadUrl(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTfxPromptRefUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTfxPromptRefUploadUrl>>
>;
export type CreateTfxPromptRefUploadUrlMutationBody = TfxPromptRefUploadUrlRequestDTO;
export type CreateTfxPromptRefUploadUrlMutationError = unknown;

/**
 * @summary Presigned PUT for a PROMPT-job reference asset (image/video) under prompt-refs/.
 */
export const useCreateTfxPromptRefUploadUrl = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTfxPromptRefUploadUrl>>,
      TError,
      { data: TfxPromptRefUploadUrlRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTfxPromptRefUploadUrl>>,
  TError,
  { data: TfxPromptRefUploadUrlRequestDTO },
  TContext
> => {
  const mutationOptions = getCreateTfxPromptRefUploadUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
